"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc721 = void 0;
var ethers_1 = require("ethers");
var abi_1 = require("./abi");
var ERC721MetadataID = '0x5b5e139f';
var ERC721EnumerableID = '0x780e9d63';
var ipfsGateway = 'https://ipfs.io/ipfs/';
/**
 *
 * @param url
 */
function fetchNftData(url) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.json()];
            }
        });
    });
}
var erc721 = /** @class */ (function () {
    function erc721(contractAddress, walletAddress, provider) {
        this.contractAddress = contractAddress;
        this.walletAddress = walletAddress;
        this.contract = new ethers_1.ethers.Contract(contractAddress, abi_1.erc721ABI, provider);
    }
    erc721.prototype.getCollectionData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var canSupportMetadata, name, symbol, canSupportEnumerable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.supportMetadata()];
                    case 1:
                        canSupportMetadata = _a.sent();
                        name = '';
                        symbol = '';
                        if (!canSupportMetadata) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.contract.name()];
                    case 2:
                        name = _a.sent();
                        return [4 /*yield*/, this.contract.symbol()];
                    case 3:
                        symbol = _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.supportEnumerable()];
                    case 5:
                        canSupportEnumerable = _a.sent();
                        return [2 /*return*/, {
                                name: name,
                                symbol: symbol,
                                logo: '',
                                canSupportEnumerable: canSupportMetadata,
                                canSupportMetadata: canSupportEnumerable,
                                enabled: false,
                                contractAddress: this.contractAddress,
                                tokens: [],
                            }];
                }
            });
        });
    };
    erc721.prototype.supportMetadata = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.metadataSupport !== undefined)
                            return [2 /*return*/, this.metadataSupport];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        _b = this;
                        return [4 /*yield*/, this.contract.supportsInterface(ERC721MetadataID)];
                    case 2:
                        _b.metadataSupport = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _c.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, (_a = this.metadataSupport) !== null && _a !== void 0 ? _a : false];
                }
            });
        });
    };
    erc721.prototype.supportEnumerable = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, e_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.enumerableSupport !== undefined)
                            return [2 /*return*/, this.enumerableSupport];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        _b = this;
                        return [4 /*yield*/, this.contract.supportsInterface(ERC721EnumerableID)];
                    case 2:
                        _b.enumerableSupport = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _c.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, (_a = this.enumerableSupport) !== null && _a !== void 0 ? _a : false];
                }
            });
        });
    };
    // get balance
    erc721.prototype.getBalance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var balance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contract.balanceOf(this.walletAddress)];
                    case 1:
                        balance = _a.sent();
                        return [2 /*return*/, Number(balance)];
                }
            });
        });
    };
    erc721.prototype.getAllTokensIds = function () {
        return __awaiter(this, void 0, void 0, function () {
            var canSupportMetadata, canSupportEnumerable, bal, res, i, tokenId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        canSupportMetadata = this.supportMetadata();
                        canSupportEnumerable = this.supportEnumerable();
                        if (!canSupportMetadata || !canSupportEnumerable)
                            return [2 /*return*/, []];
                        return [4 /*yield*/, this.getBalance()];
                    case 1:
                        bal = _a.sent();
                        res = [];
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < bal)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.contract.tokenOfOwnerByIndex(this.walletAddress, i)];
                    case 3:
                        tokenId = _a.sent();
                        res.push(tokenId.toString());
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, res];
                }
            });
        });
    };
    erc721.prototype.parseURI = function (uri) {
        // Three types of uri I have noticed so far returned by the contracts
        // 1. string with no protocol mentioned. Ex = 'QmSaadYLvZzx1GnoUFT8Tg6yUoVuM3gZ2tXHvKmQC4w41K/3769.json'
        // 2. string with ipfs protocol mentioned. Ex = ipfs://QmV9zd4czyxhxbPGdLWs7zb2G4qx9tLEHVrCGUkgWZde7D/2748.png
        // 3. string with https protocol mentioned. Ex = https://openseacreatures.io/3
        if (uri.startsWith('https://') || uri.startsWith('http://'))
            return uri;
        if (uri.startsWith('ipfs://'))
            return uri.replace('ipfs://', ipfsGateway);
        return ipfsGateway + uri;
    };
    erc721.prototype.getTokenURI = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contract.tokenURI(id)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    erc721.prototype.getAllTokenURI = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ids, res, i, id, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllTokensIds()];
                    case 1:
                        ids = _a.sent();
                        res = [];
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < ids.length)) return [3 /*break*/, 5];
                        id = ids[i];
                        return [4 /*yield*/, this.getTokenURI(parseInt(id))];
                    case 3:
                        data = _a.sent();
                        res.push({ tokenId: id, url: data });
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, res];
                }
            });
        });
    };
    erc721.prototype.getAllERC721Tokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            var allTokenURI, allTokens;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllTokenURI()];
                    case 1:
                        allTokenURI = _a.sent();
                        return [4 /*yield*/, Promise.all(allTokenURI.map(function (m) { return __awaiter(_this, void 0, void 0, function () {
                                var parsedURI, token, tokenData, e_3;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            parsedURI = this.parseURI(m.url);
                                            token = { id: m.tokenId.toString(), isFavorite: false, contractAddress: this.contractAddress };
                                            _b.label = 1;
                                        case 1:
                                            _b.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, fetchNftData(parsedURI)];
                                        case 2:
                                            tokenData = _b.sent();
                                            token = __assign(__assign(__assign({}, token), tokenData), { image: this.parseURI((_a = tokenData.image) !== null && _a !== void 0 ? _a : '') });
                                            return [3 /*break*/, 4];
                                        case 3:
                                            e_3 = _b.sent();
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/, token];
                                    }
                                });
                            }); }))];
                    case 2:
                        allTokens = _a.sent();
                        return [2 /*return*/, allTokens];
                }
            });
        });
    };
    erc721.prototype.getERC721TokenFromId = function (id) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var uri, parsedURI, token, tokenData, e_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getTokenURI(parseInt(id))];
                    case 1:
                        uri = _b.sent();
                        parsedURI = this.parseURI(uri);
                        token = { id: id, isFavorite: false, contractAddress: this.contractAddress };
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, fetchNftData(parsedURI)];
                    case 3:
                        tokenData = _b.sent();
                        token = __assign(__assign(__assign({}, token), tokenData), { image: this.parseURI((_a = tokenData.image) !== null && _a !== void 0 ? _a : '') });
                        return [3 /*break*/, 5];
                    case 4:
                        e_4 = _b.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, token];
                }
            });
        });
    };
    return erc721;
}());
exports.erc721 = erc721;
